import React, { Dispatch, SetStateAction } from 'react';
import { Button, Modal } from '@ixicare/ui';
import { t } from '~i18n';

interface ResetDemokitConfirmationModalProps {
  onConfirm: (id: number) => void;
  loading: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  siteId: number;
}

const ResetDemokitConfirmationModal: React.FC<ResetDemokitConfirmationModalProps> = ({
  onConfirm,
  loading,
  setShowModal,
  siteId,
}) => {
  if (!setShowModal) {
    return null;
  }
  return (
    <Modal style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-30">{t('siteSettings.resetDemokitModal.description')}</h3>
      <Button
        className="mb-15 error"
        disabled={loading}
        loading={loading}
        isBlock
        buttonType="error"
        type="button"
        onClick={() => onConfirm(siteId)}
      >
        {t('siteSettings.resetDemokitModal.reset')}
      </Button>
      <Button onClick={() => setShowModal(false)} disabled={loading} isBlock buttonType="link">
        {t('global.cancel')}
      </Button>
    </Modal>
  );
};

export default ResetDemokitConfirmationModal;
